/**
 * Normalize applicant / form passport values into an <img>/Avatar-safe src.
 * Form camera fields may store a plain URL, a data URI, a { url } object, or a JSON array.
 */
export const resolveApplicantPhotoSrc = (value) => {
  if (value == null || value === '') {
    return undefined;
  }

  if (Array.isArray(value)) {
    for (const item of value) {
      const nested = resolveApplicantPhotoSrc(item);
      if (nested) return nested;
    }
    return undefined;
  }

  if (typeof value === 'object') {
    return (
      resolveApplicantPhotoSrc(value.url) ||
      resolveApplicantPhotoSrc(value.fileUrl) ||
      resolveApplicantPhotoSrc(value.src) ||
      resolveApplicantPhotoSrc(value.path)
    );
  }

  const text = String(value).trim();
  if (!text) return undefined;

  if (text.startsWith('{') || text.startsWith('[')) {
    try {
      return resolveApplicantPhotoSrc(JSON.parse(text));
    } catch (err) {
      const match = text.match(/https?:\/\/[^\s"'<>\\]+/i);
      return match ? match[0] : undefined;
    }
  }

  const lower = text.toLowerCase();
  if (
    lower.startsWith('https://') ||
    lower.startsWith('http://') ||
    lower.startsWith('data:image/jpeg') ||
    lower.startsWith('data:image/png') ||
    lower.startsWith('data:image/webp')
  ) {
    return text;
  }

  return undefined;
};

export const applicantPhotoSrc = (applicant = {}) =>
  resolveApplicantPhotoSrc(applicant.imageUrl) ||
  resolveApplicantPhotoSrc(applicant.passport_picture) ||
  resolveApplicantPhotoSrc(applicant.passport) ||
  resolveApplicantPhotoSrc(applicant.passport_photo);
